
	import { Component, Prop, Vue } from 'vue-property-decorator';
	import aps from '@/HostApp/store/ApsModules/ApsModule';
	import { ISanitizeOptions } from '@/HostApp/ui/directives/index';

	@Component({})
	export default class Error404 extends Vue {
		@Prop({ required: true })
		protected localizedLabels!: APS.IError404;
		protected sanitizeOptions: ISanitizeOptions = {
			allowedTags: ['a'],
			allowedAttributes: {
				a: ['href']
			}
		};

		protected get isVueWorkspace(): boolean {
			return aps.navigation.isVueWorkspace;
		}
	}
